import {validateField, validateForm} from "../form/validator";
import {initMaskedInput, initPlaceholders} from "../form/inputs";

export function initContactsForm() {
    if (!$('#contact_form').length) {
        return
    }
    const $form = $('#contact_form');

    const $finalMessageWrapper = $('[data-contacts-form-message]');
    const $submit = $form.find('#contacts_submit');
    initPlaceholders();
    initMaskedInput();

    $form.find('input, textarea').on('change', (e) => {
        const $this = $(e.currentTarget);
        validateField($this);
        return false;
    })

    $submit.on('click', (e) => {

        if (validateForm($form)) {
            let formData = {};

            $form.find('input, textarea').each(function () {
                formData[this.name] = $(this).val();
            });

            formData['verification'] = '1';

            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                dataType: 'text',
                data: formData,
                success: () => {
                    $form.addClass('hide');
                    $finalMessageWrapper.removeClass('hide');
                },
                error: () => {
                },
                timeout: 30000
            })
        }
        return false;
    })
}
